
import aboutImage from '../../../assets/images/about_ours.png';

export default function AboutSection() {
  const services = [
    {
      icon: 'ri-search-eye-line',
      title: '管网服务解决方案',
      description: '低成本流向仪核心 ，用于雨污混接排查、负压排水及管网动态监管'
    },
    {
      icon: 'ri-tools-line',
      title: '河湖生态治理',
      description: '构建健康水下生态系统 ，实施水质提升 、面源污染治理、景观打造等'
    },
    {
      icon: 'ri-router-line',
      title: '环保、监测设备',
      description: '提供水质在线/便携监测 、MBR污水处理 , 水质提升和各类智能终端'
    },
    {
      icon: 'ri-macbook-line',
      title: '智慧运行平台',
      description: '基于GIS的数字平台 ，提供数据存储、分析、决策管理 及定制化开发'
    },
    {
      icon: 'ri-contrast-drop-2-line',
      title: '水务、排水管家服务',
      description: '为政府、企业提供水环境/排水系统一站式、全流程管理和托管服务'
    },
    {
      icon: 'ri-quill-pen-ai-line',
      title: '环境检测及工程咨询服务',
      description: 'CMA认证环境检测 、市政/环保工程施工 及环保/水土保持咨询'
    }
  ];

  return (
    <section id="about" className="py-8 md:py-16 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* 标题区：文字动态缩放，避免大屏过散、小屏溢出 */}
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-gray-900 mb-4">
            智慧环境解决方案专家
          </h2>
          <p className="text-[clamp(0.875rem,1.5vw,1rem)] text-gray-600 max-w-3xl md:max-w-4xl mx-auto leading-relaxed">
            万江环境依托自主研发与产学研合作，形成了从规划设计、产品研发、技术创新到工程实施、检测验证、运维管理的全周期解决方案，致力于为城市水环境提供一站式的智慧化服务
          </p>
        </div>

        {/* 服务卡片区：网格响应式，卡片内元素适配缩放 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-20">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-6 md:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* 图标容器：尺寸响应式，保持比例 */}
              <div
                className="w-12 md:w-16 h-12 md:h-16 rounded-xl flex items-center justify-center mb-4 md:mb-6"
                style={{ background: '#4677e0' }}
              >
                <i className={`${service.icon} text-white text-xl md:text-2xl`}></i>
              </div>
              {/* 卡片文字：动态字体，适配不同屏幕 */}
              <h3 className="text-[clamp(1rem,1.8vw,1.25rem)] font-bold text-gray-900 mb-2 md:mb-3">
                {service.title}
              </h3>
              <p className="text-[clamp(0.8125rem,1.2vw,0.875rem)] text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* 选择我们区：图片整体缩放不裁剪，文字与图片对齐 */}
        <div className="bg-white rounded-3xl p-6 md:p-8 lg:p-12 shadow-lg">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-[clamp(1.25rem,2.5vw,2rem)] font-bold text-gray-900 mb-4 md:mb-6">
                为什么选择我们？
              </h3>
              <div className="space-y-5 md:space-y-6">
                {/* 选择理由项：图标与文字适配 */}
                <div className="flex items-start space-x-3 md:space-x-4">
                  <div
                    className="w-7 md:w-8 h-7 md:h-8 rounded-lg flex items-center justify-center flex-shrink-0 mt-1"
                    style={{ backgroundColor: '#e6f2ff', color: '#4677e0' }}
                  >
                    <i className="ri-check-line text-sm md:text-base"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1.5 text-[clamp(0.9375rem,1.4vw,1rem)]">
                      专业技术团队
                    </h4>
                    <p className="text-[clamp(0.8125rem,1.2vw,0.875rem)] text-gray-600">
                      拥有10年以上水环境治理经验的专家团队，提供最专业的技术支持
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3 md:space-x-4">
                  <div
                    className="w-7 md:w-8 h-7 md:h-8 rounded-lg flex items-center justify-center flex-shrink-0 mt-1"
                    style={{ backgroundColor: '#e6f2ff', color: '#4677e0' }}
                  >
                    <i className="ri-check-line text-sm md:text-base"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1.5 text-[clamp(0.9375rem,1.4vw,1rem)]">
                      定制化方案
                    </h4>
                    <p className="text-[clamp(0.8125rem,1.2vw,0.875rem)] text-gray-600">
                      根据客户具体需求，量身定制最适合的水环境治理方案
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3 md:space-x-4">
                  <div
                    className="w-7 md:w-8 h-7 md:h-8 rounded-lg flex items-center justify-center flex-shrink-0 mt-1"
                    style={{ backgroundColor: '#e6f2ff', color: '#4677e0' }}
                  >
                    <i className="ri-check-line text-sm md:text-base"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1.5 text-[clamp(0.9375rem,1.4vw,1rem)]">
                      全程服务
                    </h4>
                    <p className="text-[clamp(0.8125rem,1.2vw,0.875rem)] text-gray-600">
                      从方案设计到落地执行，再到后期维护，提供一站式服务
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* 图片区：核心优化——整体缩放不裁剪，保持比例 */}
            <div className="relative mt-8 lg:mt-0 transition-transform duration-500 ease-out hover:z-10 hover:scale-110">
              <img
                src={aboutImage}
                alt="专业水环境治理团队"
                className="rounded-2xl shadow-lg w-full h-auto max-h-[400px] object-contain"
                style={{
                  backgroundColor: '#f5f5f5', // 图片加载前/空白区域填充色，避免突兀
                  objectFit: 'contain' // 关键：整体显示图片，不裁剪（替代原object-cover）
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
